export var PortalUserPermission;
(function (PortalUserPermission) {
    PortalUserPermission[PortalUserPermission["CanChangeConvenienceFee"] = 1] = "CanChangeConvenienceFee";
    PortalUserPermission[PortalUserPermission["CanRefundTransactions"] = 2] = "CanRefundTransactions";
    PortalUserPermission[PortalUserPermission["CanApplyPaymentInEpic"] = 4] = "CanApplyPaymentInEpic";
    PortalUserPermission[PortalUserPermission["CanViewPaymentAttachments"] = 8] = "CanViewPaymentAttachments";
    PortalUserPermission[PortalUserPermission["CanDebitReversalsInEpic"] = 16] = "CanDebitReversalsInEpic";
    PortalUserPermission[PortalUserPermission["CanModifyPfGroups"] = 32] = "CanModifyPfGroups";
    PortalUserPermission[PortalUserPermission["CanCreatePfGroups"] = 64] = "CanCreatePfGroups";
    PortalUserPermission[PortalUserPermission["CanWaiveConvenienceFees"] = 128] = "CanWaiveConvenienceFees";
})(PortalUserPermission || (PortalUserPermission = {}));
//# sourceMappingURL=PortalUserPermission.js.map